import './App.css';

import NavBar from '../NavBar/NavBar'
import PageJournalComptable from '../PageJournalComptable/PageJournalComptable'
import PageGrandLivre from '../PageGrandLivre/PageGrandLivre'
import PageBalance from '../PageBalance/PageBalance'
import PageCompteResultat from '../PageCompteResultat/PageCompteResultat'
import PageBilan from '../PageBilan/PageBilan'
import PageDataComptes from '../PageDataComptes/PageDataComptes'


import { useState } from 'react';


function appPage({pageNum}) {
  switch (pageNum) {
    case 0:
      return <PageJournalComptable />
    case 1:
      return <PageGrandLivre />
    case 2:
      return <PageBalance />
    case 3:
      return <PageCompteResultat />
    case 4:
      return <PageBilan />
    case 5:
      return <PageDataComptes />
    default:
      return alert('Erreur, page non existante')
  }
};


function App() {
  const [page, updatePage] = useState(0)


  return (
    <div className="App">
      <NavBar page={page} updatePage={updatePage} />
      
      <div>{appPage({pageNum: page})}</div>

    </div>
  );
}

export default App;
